module.exports = "<span class=\"star-box\" id=\"star-box\"></span>";